import { Route, Routes } from 'react-router-dom';

import NotFoundPage from '../../NotFound.page';
import UsersRoutes from './users';

function UsersFeatureRoutes(): JSX.Element {
  return (
    <Routes>
      <Route path="users/*" element={<UsersRoutes />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}

export default UsersFeatureRoutes;
